import Building2 from 'lucide-react/dist/esm/icons/building-2.mjs'
import CreditCard from 'lucide-react/dist/esm/icons/credit-card.mjs'
import FileText from 'lucide-react/dist/esm/icons/file-text.mjs'
import Gauge from 'lucide-react/dist/esm/icons/gauge.mjs'
import House from 'lucide-react/dist/esm/icons/house.mjs'
import LogOut from 'lucide-react/dist/esm/icons/log-out.mjs'
import Menu from 'lucide-react/dist/esm/icons/menu.mjs'
import Settings from 'lucide-react/dist/esm/icons/settings.mjs'
import Truck from 'lucide-react/dist/esm/icons/truck.mjs'
import Users from 'lucide-react/dist/esm/icons/users.mjs'
import { ReactNode, useState } from 'react'
import { useAuth } from '../auth/AuthContext'
import { NavLink, useNavigate } from '../routing/Router'
import { Logo } from './Logo'

const nav = [
  { to: '/app', label: 'Обзор', icon: House, end: true, mobile: true },
  { to: '/app/objects', label: 'Объекты', icon: Building2, mobile: true },
  { to: '/app/providers', label: 'Поставщики', icon: Truck },
  { to: '/app/receipts', label: 'Квитанции', icon: FileText, mobile: true },
  { to: '/app/meters', label: 'Счётчики', icon: Gauge, mobile: true },
  { to: '/app/family', label: 'Семья', icon: Users, mobile: true },
  { to: '/app/payments', label: 'Платежи', icon: CreditCard },
  { to: '/app/settings', label: 'Настройки', icon: Settings },
]
const mobileNav = nav.filter((item) => item.mobile)

export function AppLayout({ children }: { children: ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  async function signOut() {
    await logout()
    navigate('/')
  }

  return (
    <div className="app-shell">
      <header className="mobile-topbar">
        <button className="icon-button" onClick={() => setMenuOpen((value) => !value)} aria-label="Открыть меню">
          <Menu size={22} />
        </button>
        <Logo />
        <span className="avatar">{user?.displayName.slice(0, 1).toUpperCase()}</span>
      </header>
      {menuOpen && <button className="mobile-menu-backdrop" onClick={() => setMenuOpen(false)} aria-label="Закрыть меню" />}
      <aside className={`sidebar ${menuOpen ? 'is-open' : ''}`}>
        <Logo />
        <nav className="sidebar-nav" aria-label="Основная навигация">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} onClick={() => setMenuOpen(false)}>
              <Icon size={20} strokeWidth={1.7} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-privacy">
          <span className="shield-mini">✓</span>
          <span>Данные используются только для работы сервиса</span>
        </div>
        <div className="sidebar-user">
          <span className="avatar">{user?.displayName.slice(0, 1).toUpperCase()}</span>
          <span className="sidebar-user-copy">
            <strong>{user?.displayName}</strong>
            <small>{user?.email ?? user?.phone}</small>
          </span>
          <button className="icon-button" onClick={signOut} aria-label="Выйти">
            <LogOut size={18} />
          </button>
        </div>
      </aside>
      <main className="app-main">
        {children}
      </main>
      <nav className="mobile-bottom-nav" aria-label="Мобильная навигация">
        {mobileNav.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end}>
            <Icon size={20} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
